import React, { FC } from 'react';
import { btnStyleClassMapping, iconPosition } from './constants';
import { ButtonProps } from './typing';
import './style.scss';

const Button: FC<ButtonProps> = (props): JSX.Element => {
  const {
    label,
    onClick,
    enable,
    btnStyleClass,
    type,
    btnStyleType = 'secondary',
    btnIcon,
    btnIconPosition,
    loading = false,
    loadingLabel,
    disabled = false,
  } = props;
  const isDisabled = !enable || loading || disabled;

  return (
    <button
      disabled={isDisabled}
      type={type || 'button'}
      className={`${btnStyleClassMapping[btnStyleType]} ${btnStyleClass || ''}${
        isDisabled ? ' dissable disabled' : ''
      }${
        loading ? ' button-loading' : ''
      }`}
      onClick={onClick}
      aria-busy={loading}
      {...(props.form ? { form: props.form } : {})}
    >
      {loading ? (
        <span className='button-loader' />
      ) : (
        btnIconPosition === iconPosition.LEFT && btnIcon
      )}
      {loading ? loadingLabel || label : label}
      {!loading && btnIconPosition === iconPosition.RIGHT && btnIcon}
    </button>
  );
};

export default Button;
